'use strict';

require('site');
